// Customer Dashboard
import { useQuery } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import { appointmentsAPI } from '../../api'
import { useAuth } from '../../context/AuthContext'
import { RiCalendarCheckLine, RiTimeLine, RiArrowRightLine, RiLoader4Line } from 'react-icons/ri'
import { Helmet } from 'react-helmet-async'

export default function CustomerDashboard() {
  const { user } = useAuth()

  const { data: upcoming } = useQuery({
    queryKey: ['my-upcoming'],
    queryFn: () => appointmentsAPI.getMine({ status: 'confirmed', per_page: 3 }),
    select: (r) => r.data?.data || [],
  })

  const STATUS_COLORS = {
    confirmed: 'badge-green',
    pending:   'badge-gold',
    cancelled: 'badge-red',
    completed: 'badge-primary',
  }

  return (
    <>
      <Helmet><title>Dashboard – Salon Vora</title></Helmet>
      <section className="py-12">
        <div className="container-salon">
          <div className="mb-8">
            <h1 className="font-display text-salon-dark text-3xl font-bold">
              Welcome back, {user?.name?.split(' ')[0]} 👋
            </h1>
            <p className="text-salon-muted font-body mt-1">Manage your appointments and profile here.</p>
          </div>

          <div className="grid sm:grid-cols-2 gap-6 mb-8">
            <Link to="/book" className="card p-6 flex items-center gap-5">
              <div className="w-14 h-14 rounded-2xl bg-salon-primary/10 flex items-center justify-center">
                <RiCalendarCheckLine className="text-salon-primary text-2xl" />
              </div>
              <div>
                <p className="font-display text-salon-dark text-lg font-bold">Book Appointment</p>
                <p className="text-salon-muted font-body text-sm">Schedule your next visit</p>
              </div>
              <RiArrowRightLine className="ml-auto text-salon-primary" />
            </Link>
            <Link to="/dashboard/appointments" className="card p-6 flex items-center gap-5">
              <div className="w-14 h-14 rounded-2xl bg-salon-secondary/10 flex items-center justify-center">
                <RiTimeLine className="text-salon-secondary text-2xl" />
              </div>
              <div>
                <p className="font-display text-salon-dark text-lg font-bold">My Appointments</p>
                <p className="text-salon-muted font-body text-sm">View all your bookings</p>
              </div>
              <RiArrowRightLine className="ml-auto text-salon-secondary" />
            </Link>
          </div>

          <div className="bg-white rounded-2xl border border-salon-cream-dark p-6">
            <h3 className="font-semibold font-body text-salon-dark mb-4">Upcoming Appointments</h3>
            {!upcoming?.length ? (
              <div className="text-center py-10">
                <p className="text-salon-muted font-body text-sm">No upcoming appointments.</p>
                <Link to="/book" className="btn-primary inline-flex mt-4 text-sm">Book Now</Link>
              </div>
            ) : (
              <div className="space-y-3">
                {upcoming.map((a) => (
                  <div key={a.id} className="flex items-center justify-between p-4 rounded-xl bg-salon-cream border border-salon-cream-dark">
                    <div>
                      <p className="font-semibold text-salon-dark font-body">{a.services?.map((s) => s.name).join(', ')}</p>
                      <p className="text-salon-muted text-sm font-body">{a.date} at {a.time} · {a.staff?.name || 'Any stylist'}</p>
                    </div>
                    <span className={`badge capitalize ${STATUS_COLORS[a.status]}`}>{a.status}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  )
}
